import request from 'utils/request'

export const getMCAXS461InitRequest = () =>
  request({
    url: '/MCAXS461/init',
    method: 'post',
  })
